<template>
  <div class="activity-share-root">
    <div class="background">
      <div class="footerbjcss"></div>
      <div class="xiaoyuheqp"></div>
    </div>
    <div class="error-tip" v-show="errorMessage.length > 0">
      <div class="mid">
        <div>出错了： {{ errorMessage }}</div>
        <br />
<!--        <router-link to="/"-->
<!--          ><div class="home-button">回到首页</div></router-link-->
<!--        >-->
      </div>
    </div>
    <div
      class="container"
      v-loading="isLoading"
      v-show="errorMessage.length === 0"
    >
      <div class="info" v-for="app of versionList" :key="app.id">
        <div class="title">{{ titleEnum[app.platform] }}下载</div>
        <div class="code">
          <canvas class="qrcode" :ref="setItemRef"></canvas>
          <img class="logo" width="40" :src="app.logo" />
        </div>
        <div class="app-name">{{ app.name }}</div>
        <div class="size">{{ app.size }}</div>
        <div class="version">{{ app.version }}</div>
        <div class="updated-date">{{ app.updatedDate }}</div>
        <div class="download">
          <el-button
            type="primary"
            size="large"
            @click="handleDownload(app.origin)"
            >应用下载</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      v-model="dialogVisible"
      title="请输入密码"
      width="300px"
      top="35vh"
      :close-on-click-modal="false"
    >
      <el-input v-model="password" v-tc-auto-focus="dialogVisible" />
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="handleConfirm">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import {
  apiGetActivityShareInfo,
  apiGetApplePackageUrlForComputer,
  apiGetPackageUrl,
} from "@/Api/AppApi";
import { humanSize } from "@/Utils/UtilTools";
import { ref, onMounted, watch, getCurrentInstance, onBeforeUpdate } from "vue";
import { useRoute } from "vue-router";
import QRCode from "qrcode";

const { appContext } = getCurrentInstance();
const $message = appContext.config.globalProperties.$message;
const $moment = appContext.config.globalProperties.$moment;

const route = useRoute();

const uri = ref("");
let versionid = "";
watch(
  () => route.params?.uri,
  (val) => {
    if (route.path.includes("/activity")) {
      if (val) {
        errorMessage.value = "";
        uri.value = val;
        versionid = route.query.versionid;
        getActivityShareInfo();
      } else {
        errorMessage.value = "缺少app短链";
      }
    }
  },
  { immediate: true }
);
onMounted(() => {
  uri.value = route.params?.uri;
  versionid = route.query.versionid;
  getActivityShareInfo();
});

const itemRefs = ref([]);
const setItemRef = (el) => {
  if (el) {
    itemRefs.value.push(el);
  }
};
onBeforeUpdate(() => {
  itemRefs.value = [];
});
watch(itemRefs, (refs) => {
  if (refs.length > 0) {
    for (let i = 0; i < refs.length; i++) {
      const ref = refs[i];
      genQRCode(ref, versionList.value[i].id);
    }
  }
});

const titleEnum = {
  1: "iOS",
  2: "Android",
  3: "Windows",
  4: "MacOS",
  5: "Linux",
};

const isLoading = ref(false);
const errorMessage = ref("");
const versionList = ref([]);
async function getActivityShareInfo() {
  versionList.value = [];
  isLoading.value = true;
  const res = await apiGetActivityShareInfo(uri.value);
  isLoading.value = false;
  if (res.code === 0) {
    errorMessage.value = "";
    const activity = res.data;
    for (const version of activity.versions) {
      // 这里 v.activityid 可能不对(是版本 share 的 id), 所以手动赋值一下
      if (version.package.platform === 1) {
        version.activityid = activity.activityid;
      } else if (version.package.platform === 2) {
        version.activityid = activity.activityid;
      }

      if (!versionid || versionid === version.id) {
        const pack = version.package;

        versionList.value.push({
          name: pack.appname,
          size: humanSize(pack.size, 1),
          version: `${pack.version} (BUILD ${pack.buildnumber})`,
          updatedDate: $moment(version.createtime).format("YYYY/MM/DD HH:mm"),
          logo: pack.logo,
          id: version.id,
          platform: pack.platform,
          origin: version,
        });
      }
    }
  } else {
    if (res.code === 28) {
      errorMessage.value = "没有找到对应的app";
    } else {
      errorMessage.value = res.message;
    }
  }
}

function genQRCode(el, id) {
  QRCode.toCanvas(
    el,
    location.href + "?versionid=" + id,
    {
      maskPattern: 4,
      width: 180,
      margin: 2,
      errorCorrectionLevel: "H",
    },
    (err) => {
      if (err) {
        console.log(err);
        errorMessage.value = "二维码生成失败";
      }
    }
  );
}

let app = null;
const password = ref("");
const dialogVisible = ref(false);
function handleDownload(_app) {
  app = _app;
  if (app.password === "true") {
    dialogVisible.value = true;
  } else {
    doDownload();
  }
}
function handleConfirm() {
  if (password.value.length > 0) {
    dialogVisible.value = false;
    doDownload();
  } else {
    $message({ type: "warning", message: "密码为空，请输入密码。" });
  }
}

async function getPackageUrl() {
  const versionId = app.id;
  let res;
  if (app.package.platform === 1) {
    const data = {
      password: password.value,
      activityid: app.activityid,
    };
    res = await apiGetApplePackageUrlForComputer(app.appid, versionId, data);
  } else {
    const data = {
      id: versionId,
      password: password.value,
      activityid: app.activityid,
    };
    res = await apiGetPackageUrl(data);
  }

  if (res.code === 0) {
    return res.data;
  } else if (res.code === 30000) {
    $message({
      type: "error",
      message: "密码错误，请重新输入密码。",
    });
  } else {
    $message({
      type: "error",
      message: res.message,
    });
  }
}

let downloading = false;
async function doDownload() {
  if (downloading) {
    return;
  }

  downloading = true;
  const url = await getPackageUrl();
  downloading = false;
  if (url) {
    const node = document.createElement("a");
    node.href = url;
    node.click();
    node.remove();
  }
}
</script>

<style lang="scss" scoped>
.activity-share-root {
  background-color: #59b0ff;
  width: 100%;
  height: 100%;
}

.background {
  .footerbjcss {
    background-image: url(/assets/images/404footer.png);
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    bottom: 0;
    height: 48%;
    width: 100%;
  }
  .xiaoyuheqp {
    background-image: url(/assets/images/yuheqp.png);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
  }
}

.error-tip {
  color: #fff;
  font-size: 16px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;

  .home-button {
    color: #fff;
    cursor: pointer;
    width: 200px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 24px;
    user-select: none;
    background-color: #1a7dd7;
  }
}

.container {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: NotoSansHans-Medium;

  .info {
    width: 320px;
    height: 420px;
    border-radius: 6px;
    background-color: #fff;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
    text-align: center;
    margin: 0 12px;

    .title {
      font-size: 16px;
      padding-left: 20px;
      height: 40px;
      color: #333333;
      line-height: 39px;
      border-bottom: 1px solid #eaeaea;
      text-align: left;
    }

    .code {
      position: relative;
      margin-top: 24px;

      .qrcode {
        border: 1px solid #eaeaea;
      }

      .logo {
        position: absolute;
        top: 70px;
        left: calc(50% - 20px);
      }
    }

    .app-name {
      margin-top: 13px;
      font-size: 16px;
      color: #333333;
    }

    .size,
    .version,
    .updated-date {
      margin-top: 6px;
      font-size: 12px;
      color: #949494;
    }

    .download {
      button {
        padding: 12px 40px;
        margin-top: 18px;
      }
    }
  }
}
</style>
